import { Transformer } from '../compatibility/transformer';
import { Message } from './message';
import { Subscriber } from './subscriber';
import { Topic } from './topic';
import { WindowProvider } from './windowProvider';
export class PubSub {
    constructor(actorId, releaseVersion, modelVersion) {
        this.logEnabled = true;
        this.callbacks = [];
        this.subscribers = [];
        this.publish = (topic, payload, modelVersion, destination) => {
            this.postMessage(new Message(this.actorId, 2, payload, this.actorId, modelVersion, topic, destination));
        };
        this.subscribe = (topic, callback, modelVersion) => {
            this.postMessage(new Message(this.actorId, 3, topic, this.actorId, modelVersion, topic));
            this.callbacks[topic] = callback;
        };
        this.unsubscribe = (topic) => {
            this.postMessage(new Message(this.actorId, 4, topic, this.actorId, null, topic));
            delete this.callbacks[topic];
        };
        this.setLogEnabled = (bool) => {
            this.logEnabled = bool;
        };
        this.handleMessageEvent = (event) => {
            if (!event || !event.source || !event.origin) {
                return;
            }
            else if (this.actorId === "SERVER") {
                this.handleMessageEventToServer(event);
            }
            else {
                this.handleMessageEventToClient(event);
            }
        };
        this.log = (log) => {
            if (this.logEnabled) {
                console.debug(`[AWP Lib] [${this.actorId}]:`, log);
            }
        };
        this.postMessage = (message) => {
            this.serverWindow.postMessage(message, this.serverWindowOrigin);
        };
        this.setServerWindowForIFrames = () => {
            if (this.serverWindow !== this.ownWindow.parent) {
                this.serverWindow = this.ownWindow.parent;
                const loc = this.ownWindow.document.location;
                if (loc.ancestorOrigins && loc.ancestorOrigins[0]) {
                    this.serverWindowOrigin = loc.ancestorOrigins[0];
                }
                else {
                    this.serverWindowOrigin = this.ownWindow.document.referrer;
                }
            }
        };
        this.actorId = actorId;
        this.ownWindow = WindowProvider.getWindow();
        this.serverWindow = this.ownWindow;
        this.serverWindowOrigin = this.ownWindow.location.protocol + '//' + this.ownWindow.location.host;
        this.log(`Initializing as ${this.actorId} using lib release ${releaseVersion} and model version ${modelVersion}.`);
        this.ownWindow.addEventListener('message', this.handleMessageEvent, false);
        if (actorId !== "SERVER") {
            this.setServerWindowForIFrames();
            this.postMessage(new Message(this.actorId, 1, "HELLO", this.actorId, null, null));
        }
    }
    handleMessageEventToServer(event) {
        const msg = event.data;
        switch (msg.msgType) {
            case 1:
                if (msg.payload === "PING" || msg.payload === "HELLO") {
                    this.log(`Got HELLO from [${msg.sender}]`);
                    this.publish(Topic.CLIENT_INITIALIZATION, msg.sender, msg.version);
                }
                break;
            case 3:
                this.log(`Got SUB from [${msg.sender}] to topic [${msg.payload}]`);
                this.subscribers = this.subscribers.filter((s) => s.topic !== msg.topic || s.id !== msg.sender);
                this.subscribers.push(new Subscriber(msg.sender, msg.version, event.source, event.origin, msg.payload));
                break;
            case 4:
                this.log(`Got UNSUB from [${msg.sender}] to topic [${msg.payload}]`);
                this.subscribers = this.subscribers.filter((s) => s.topic !== msg.topic || s.id !== msg.sender);
                break;
            case 2:
                this.handlePubMessageEventToServer(msg);
                break;
            case 0:
                this.handleMessageTypeCallback(msg);
                break;
            default:
                break;
        }
    }
    handlePubMessageEventToServer(msg) {
        if (msg.topic === Topic.REPUBLISH) {
            this.log(`Got request from [${msg.sender}] to republish topic [${msg.payload}]`);
        }
        else {
            this.log(`Got PUB from [${msg.sender}] to topic [${msg.topic}]`);
        }
        let topicSubscribers = this.subscribers.filter((subscriber) => subscriber.topic === msg.topic);
        if (msg.destination) {
            topicSubscribers = topicSubscribers.filter((subscriber) => subscriber.id === msg.destination);
        }
        this.log(`Found [${topicSubscribers.length}] subscribers for [${msg.topic}]`);
        for (const subscriber of topicSubscribers) {
            const payload = Transformer.transform(msg.version, subscriber.version, msg.payload, msg.topic);
            const pubMsg = new Message(this.actorId, 0, payload, msg.sender, msg.version, msg.topic, subscriber.id);
            subscriber.ownWindow.postMessage(pubMsg, subscriber.origin);
        }
    }
    handleMessageEventToClient(event) {
        const msg = event.data;
        if (msg.destination !== this.actorId) {
            return;
        }
        if (msg.msgType === 0) {
            this.handleMessageTypeCallback(msg);
        }
    }
    handleMessageTypeCallback(msg) {
        if (msg.destination === this.actorId) {
            this.log(`Got CALLBACK from [${msg.sender}] and originator [${msg.originator}] to topic [${msg.topic}]`);
            if (msg.topic && this.callbacks[msg.topic]) {
                this.callbacks[msg.topic](msg);
            }
            else {
                this.log(`Unknown CALLBACK from [${msg.sender}] and originator [${msg.originator}] to topic [${msg.topic}]`);
            }
        }
    }
}
//# sourceMappingURL=pubsub.js.map